import { render } from "./FormPacienteMilitar.vue?vue&type=template&id=75b3a882&scoped=true"
import script from "./FormPacienteMilitar.vue?vue&type=script&lang=js"
export * from "./FormPacienteMilitar.vue?vue&type=script&lang=js"

import "./FormPacienteMilitar.vue?vue&type=style&index=0&id=75b3a882&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b3a882"]])

export default __exports__